<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17QzZmu/tc-custom/9781488086250.jpg?1726519109845" alt="This image is the cover for the book Christmas Cover-Up, Family Reunions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmas Cover-Up, Family Reunions
      </h1>
      <p class="bookDescription body article font2">
        <b>A detective must find her missing sister with the help of a former agent from her troubled past in this wholesome holiday romantic thriller.</b><br/><br/>Seven-year-old Lucy Randall was kidnapped in broad daylight fourteen years ago. With little information to go on, the investigation went cold. Now Lucy’s sister, Detective Katie Randall, is determined to find the truth. But solving the case will require facing another demon from her past . . . <br/><br/>Former FBI Agent Jordan Grey knows that Katie isn’t to blame for his brother’s death—but the rest of his family still holds her responsible. When Katie comes to him for help, he agrees to help her find Lucy—even as he promises himself not to fall for the beautiful detective. As the holiday season approaches, Katie and Jordan get close to the truth. And Jordan will do anything to protect her from a deadly kidnapper . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lynette Eason
      </h2>
      
      <p class="authorDescription body article">Lynette Eason lives in Simpsonville, SC with her husband and two children. She is an award-winning, best-selling author who spends her days writing when she&#39;s not traveling around the country teaching at writing conferences. Lynette enjoys visits to the mountains, hanging out with family and brainstorming stories with her fellow writers. You can visit Lynette&#39;s website to find out more at www.lynetteeason.com or like her Facebook page at www.facebook.com/lynette.eason</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?591052dc